import * as R from 'ramda';
import curry from 'ramda/es/curry';
export const noop = () => { };
/**
 * Clone function is temporarily which implements JSON stringify parse hack.
 * Deep cloning functionality will be implemented in future.
 */
export const clone = (object) => {
    return object ? JSON.parse(JSON.stringify(object)) : {};
};
/*
  * getOrElse function return the curry function, to which you pass default and actual value,
  * returns default value if actual value is not present.
  * @param {*} object
*/
export const getOrElse = curry((defaultValue, value) => value === undefined ? defaultValue : value);
/**
 * Debounce certain function `fn` execution by given `wait`.
 * If the `fn` is immediately called, previous call to `fn` will be discarded
 * and new call will be scheduled.
 * @export
 * @param {any} fn The function that will be executed with some delay.
 * @param {any} wait The amount of time by which to debounce the function.
 * @returns A delayed function which should be used instead of original `fn` function
 */
export function debounce(fn, wait) {
    let timeout = 0;
    return function _bouncer() {
        const context = this;
        const args = arguments;
        if (timeout > 0) {
            clearTimeout(timeout);
            timeout = 0;
        }
        timeout = window.setTimeout(() => {
            fn.apply(context, args);
            timeout = 0;
        }, wait);
    };
}
/**
 * Stops the default behavior of the event.
 * @param e event data
 */
export function stopDefaultEventBehavior(e) {
    e.stopPropagation();
    e.preventDefault();
}
// TODO: There is a corner case where two files can have same lastModified value
//       i.e. when we copy a file from another machine which is modified exactly at the same time.
//       Need to find solution for this.
/**
 * Check if the file is already uploded. It checks name and lastModified values which will be unique.
 * @param files - List of all files to upload.
 * @param file - A new file to upload.
 */
export function isDuplicateFile(files, file) {
    return files.findIndex((x) => x.lastModified === file.lastModified && x.name === file.name) >= 0;
}
export const isEmptyObject = (val) => R.isEmpty(val) || R.isNil(val);
//# sourceMappingURL=index.js.map